'use client'

import { useAtomValue } from 'jotai'
import { fromTokenUSDAmountAtom } from '@/src/stores/swap/atoms'

export const FromAmountUSDLabel = () => {
  const amount = useAtomValue(fromTokenUSDAmountAtom)

  return <p className='text-secondary text-sm'>{amount}</p>
}
